import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getLoyaltyTransactions,
  getLoyaltyUserPoints,
} from "../../../redux/loyaltyPoints/action";
import NormalCardHeader from "../../Common/CardHeader/NormalCardHeader";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

const typeLabels = {
  1: { label: "Earned", className: "badge-earned" },
  2: { label: "Redeemed", className: "badge-redeemed" },
  3: { label: "Manual Credit", className: "badge-manual-credit" },
  4: { label: "Manual Debit", className: "badge-manual-debit" },
  5: { label: "Review points", className: "badge-review-reward" },
};

const LoyaltyTransactions = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.reusableSlice.LoyaltyTransactions);
  const userPoints = useSelector(
    (state) => state.reusableSlice.LoyaltyUserPoints,
  );

  const transactions = data?.transactions || [];
  const pagination_meta = data?.pagination_meta;

  const [params, setParams] = useState({
    page: 1,
    per_page: "10",
    search_key: "",
    transaction_type: "",
    from_date: "",
    to_date: "",
  });

  const [userModal, setUserModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    const payload = { ...params };
    if (payload.transaction_type === "") delete payload.transaction_type;
    if (payload.from_date === "") delete payload.from_date;
    if (payload.to_date === "") delete payload.to_date;
    dispatch(getLoyaltyTransactions(payload));
  }, [dispatch, params]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setParams((prev) => ({
      ...prev,
      [name]:
        name === "transaction_type"
          ? value === ""
            ? ""
            : parseInt(value, 10)
          : value,
      page: 1,
    }));
  };

  const handlePageChange = (newPage) => {
    setParams((prev) => ({ ...prev, page: newPage }));
  };

  const handleUserClick = (userId, userName) => {
    setSelectedUser({ id: userId, name: userName });
    dispatch(getLoyaltyUserPoints(userId));
    setUserModal(true);
  };

  const toggleUserModal = () => {
    setUserModal(!userModal);
    if (userModal) setSelectedUser(null);
  };

  return (
    <div>
      <NormalCardHeader params={params} setParams={setParams} />

      {/* Filters */}
      <div className="loyalty-filter-row mt-3">
        <label>Filter by</label>
        <select
          name="transaction_type"
          value={params.transaction_type}
          onChange={handleFilterChange}
          className="form-control"
        >
          <option value="">All Types</option>
          <option value="1">Earned</option>
          <option value="2">Redeemed</option>
          <option value="3">Manual Credit</option>
          <option value="4">Manual Debit</option>
          <option value="5">Review Points</option>
        </select>

        <label>From</label>
        <input
          type="date"
          name="from_date"
          value={params.from_date}
          onChange={handleFilterChange}
          className="form-control"
        />

        <label>To</label>
        <input
          type="date"
          name="to_date"
          value={params.to_date}
          onChange={handleFilterChange}
          className="form-control"
        />
      </div>

      {/* Table */}
      <div className="table-category mt-3">
        <div className="table-sec table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>ID</th>
                <th>User</th>
                <th>Type</th>
                <th>Points</th>
                <th>Balance</th>
                <th>SAR Equiv</th>
                <th>Reference</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {transactions.length > 0 ? (
                transactions.map((txn) => {
                  const typeInfo = typeLabels[txn.transaction_type] || {
                    label: "-",
                    className: "",
                  };
                  return (
                    <tr key={txn.id}>
                      <td>{txn.id}</td>
                      <td>
                        <span
                          className="clickable-user"
                          onClick={() =>
                            handleUserClick(txn.user_id, txn.user_name)
                          }
                        >
                          {txn.user_name}
                        </span>
                        <br />
                        <small className="text-muted">{txn.contact}</small>
                      </td>
                      <td>
                        <span
                          className={`loyalty-type-badge ${typeInfo.className}`}
                        >
                          {txn.transaction_type_label || typeInfo.label}
                        </span>
                      </td>
                      <td>{txn.points}</td>
                      <td style={{ whiteSpace: "nowrap" }}>
                        {txn.old_balance}{" "}
                        <span className="balance-arrow">&rarr;</span>{" "}
                        {txn.new_balance}
                      </td>
                      <td>
                        {txn.sar_equivalent != null
                          ? `${txn.sar_equivalent} SAR`
                          : "-"}
                      </td>
                      <td>{txn.reference || "-"}</td>
                      <td style={{ whiteSpace: "nowrap" }}>{txn.created_on}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No transactions found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <div className="d-flex justify-content-between align-items-center">
            <div className="mb-3">
              <select
                className="form-select"
                value={params.per_page || 10}
                onChange={(e) =>
                  setParams((prev) => ({
                    ...prev,
                    page: 1,
                    per_page: e.target.value,
                  }))
                }
                style={{ width: "100px" }}
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
            {pagination_meta && (
              <CommonPagination
                currentPage={pagination_meta.current_page}
                totalPages={pagination_meta.pages}
                onPageChange={handlePageChange}
              />
            )}
          </div>
        </div>
      </div>

      {/* User Points Modal */}
      <Modal
        isOpen={userModal}
        toggle={toggleUserModal}
        className="loyalty-user-modal"
      >
        <ModalHeader toggle={toggleUserModal}>
          User Points - {selectedUser?.name || ""}
        </ModalHeader>
        <ModalBody>
          {userPoints ? (
            <div>
              <div className="points-summary-item">
                <span className="label">User ID</span>
                <span className="value">{userPoints.user_id}</span>
              </div>
              <div className="points-summary-item">
                <span className="label">Current Balance</span>
                <span className="value">
                  {userPoints.current_balance} points
                </span>
              </div>
              <div className="points-summary-item">
                <span className="label">Total Earned</span>
                <span className="value">{userPoints.total_earned} points</span>
              </div>
              <div className="points-summary-item">
                <span className="label">Total Redeemed</span>
                <span className="value">
                  {userPoints.total_redeemed} points
                </span>
              </div>
            </div>
          ) : (
            <p className="text-center text-muted">Loading...</p>
          )}
        </ModalBody>
      </Modal>
    </div>
  );
};

export default LoyaltyTransactions;
